var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"all"},[_c('DateRange',{attrs:{"onChange":_vm.onDatesChange}}),(_vm.loaded)?_c('line-chart-original',{attrs:{"data":{
    labels: _vm.labels.map(e => isNaN(e) ? e : _vm.formatTimestamp(e)),
      datasets: _vm.lines.map(v => Object.assign({}, _vm.defaultDataset, v))
    },"options":{responsive: true, maintainAspectRatio: false}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }